export const APP_PAGES_LIST_REQUEST = "APP_PAGES_LIST_REQUEST";
export const APP_PAGES_LIST_SUCCESS = "APP_PAGES_LIST_SUCCESS";
export const APP_PAGES_LIST_FAIL = "APP_PAGES_LIST_FAIL";

export const APP_PAGE_GET_REQUEST = "APP_PAGE_GET_REQUEST";
export const APP_PAGE_GET_SUCCESS = "APP_PAGE_GET_SUCCESS";
export const APP_PAGE_GET_FAIL = "APP_PAGE_GET_FAIL";

export const APP_PAGE_CREATE_REQUEST = "APP_PAGE_CREATE_REQUEST";
export const APP_PAGE_CREATE_SUCCESS = "APP_PAGE_CREATE_SUCCESS";
export const APP_PAGE_CREATE_FAIL = "APP_PAGE_CREATE_FAIL";

export const APP_PAGE_UPDATE_REQUEST = "APP_PAGE_UPDATE_REQUEST";
export const APP_PAGE_UPDATE_SUCCESS = "APP_PAGE_UPDATE_SUCCESS";
export const APP_PAGE_UPDATE_FAIL = "APP_PAGE_UPDATE_FAIL";

export const APP_PAGE_DELETE_REQUEST = "APP_PAGE_DELETE_REQUEST";
export const APP_PAGE_DELETE_SUCCESS = "APP_PAGE_DELETE_SUCCESS";
export const APP_PAGE_DELETE_FAIL = "APP_PAGE_DELETE_FAIL";

export const APP_PAGE_VERSIONS_REQUEST = "APP_PAGE_VERSIONS_REQUEST";
export const APP_PAGE_VERSIONS_SUCCESS = "APP_PAGE_VERSIONS_SUCCESS";
export const APP_PAGE_VERSIONS_FAIL = "APP_PAGE_VERSIONS_FAIL";

export const APP_PAGE_RESTORE_REQUEST = "APP_PAGE_RESTORE_REQUEST";
export const APP_PAGE_RESTORE_SUCCESS = "APP_PAGE_RESTORE_SUCCESS";
export const APP_PAGE_RESTORE_FAIL = "APP_PAGE_RESTORE_FAIL";
